@if (addresses() && addresses()?.length! > 0) {
  <div
    id="store-addresses"
    class="mt-big"
  >
    <common-ui-components-title-summary
      [title]="'آدرس شعب حضوری'"
      [showButton]="false"
      [wrapperClasses]="'mb-small'"
    ></common-ui-components-title-summary>
    <div class="d-flex flex-column gap-minus">
      @for (address of addresses(); track $index) {
        <div
          class="px-medium py-minus radius-medium surface-back d-flex gap-minus align-items-center position-relative"
          (click)="goToGoogleMap(address)"
        >
          @if ($first) {
            <div class="nearest-branch">
              <ngx-badge
                [status]="'info'"
                [size]="'tiny'"
              >
                نزدیک‌ترین شعبه
              </ngx-badge>
            </div>
          }
          <div class="location-icon-container radius-rounded surface-elevated">
            <common-icon-dp-icon
              [icon]="'Location'"
              [classes]="'text-onback-brand'"
              [iconSize]="'20'"
            ></common-icon-dp-icon>
          </div>
          <div class="d-flex flex-column gap-low flex-grow">
            <div class="d-flex justify-content-space-between align-items-center">
              <span class="bt-2 text-onback-high">{{ address.title }}</span>
              <ngx-button
                [mode]="'form'"
                [style]="'link'"
                [size]="'tiny'"
                [leftIcon]="{ name: 'arrow-left', type: 'linear' }"
              >
                مسیریابی
              </ngx-button>
            </div>
            <span class="c-3 text-onback-medium">{{ address.address }}</span>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="d-flex justify-content-center">
    @if (this.showMoreStatus() === 'visible') {
      <ngx-button
        [mode]="'form'"
        [style]="'link'"
        [size]="'small'"
        [rightIcon]="{
          name: 'arrow-2-down',
          type: 'linear',
        }"
        (click)="showMore()"
      >
        بیشتر
      </ngx-button>
    } @else if (this.showMoreStatus() === 'pending') {
      <div class="mt-pony h-26">
        <ngx-spinner
          size="sm"
          color="primary"
        ></ngx-spinner>
      </div>
    }
  </div>
}
